import React, {Component} from "react";
import FlexView from "react-flexview";
import * as R from "ramda";
import {monthOptions, yearOptions} from "../config";
import {configDaily} from "./config";
import {removeNullFields} from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleNestedTable from "../../../../../modules/SimpleNestedTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import moment from "moment";

class DailySalesReport extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = moment().month();
    this.currentYear = moment().year();
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      // month: monthOptions.find((item) => item.value === currentDate.getMonth()),
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear()
      ),
    }));
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (!R.equals(prevProps.search, this.props.search)) {
  //     this.fetchData();
  //   }
  // }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  formatDate = (days, month, year) => {
    return moment(`${days}-${month}-${year}`, 'DD-MM-YYYY').format(
      "DD/MM/YYYY"
    );
  }

  constructConfig(value) {
    if (!value?.dataSalesDaily?.length) return [];

    const config = value.dataSalesDaily.map((item) => {
      const objPercent = item.leasingName
        ? item?.dailyPercentMSCP
        : item.dailyPercentSP;
    
      const percentSource =
        objPercent && typeof objPercent === "object"
          ? objPercent
          : Object.fromEntries(
              Object.keys(item.dailyCash || {}).map((key) => [key, 0])
            );

      return {
        key: item.leasingName || item.paymentMethod,
        label: item.leasingName || item.paymentMethod,
        percentSP: Object.fromEntries(
          Object.entries(percentSource).map(([key, value]) => [
            key,
            `${value}%`,
          ])
        ),
        ...item,
      };
    });

    config.push({
      key: "total",
      label: "Total",
      dailyCash: value.totalDailyCash,
      dailyAccumulation: value.totalDailyAccumulation,
    });

    return config;
  }

  fetchData = async () => {
    try {
      this.props.triggerLoading();
      const kodeCabang = this.props.isAllSelected
        ? this.props.dataCabang.map(item => item.kodeCabang)
        : this.props.search;

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarian,
        setError: this.props.setError,
        menuName: "Dashboard Kacab Keatas - Laporan Jual Harin By Cabang",
        args: {
          kodeCabang,
          year: this.state.year?.value,
          month: this.state.month?.value,
          employeeIdTeamLeader: this.props.idLeader,
        },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const daysCount = Object.keys(
          res.data.data?.totalDailyCash || {}
        ).length;

        this.setState((prevValue) => ({
          ...prevValue,
          tableConfig: this.constructConfig(res.data.data),
          dataTable: Array.from({ length: daysCount }, (_, i) => this.formatDate(i + 1, this.state.month?.value, this.state.year?.value)),
        }));
      }
      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("Error Fetching", error);
    } 
  };

  handleSearch = () => {
    this.fetchData();
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={this.handleSearch}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleNestedTable
          data={this.state.dataTable}
          config={this.state.tableConfig}
        />
      </>
    );
  }
}

export default DailySalesReport;